import { render, staticRenderFns } from "./brand-detail-origin.vue?vue&type=template&id=c1298024&scoped=true"
import script from "./brand-detail-origin.vue?vue&type=script&lang=js"
export * from "./brand-detail-origin.vue?vue&type=script&lang=js"
import style0 from "./brand-detail-origin.vue?vue&type=style&index=0&id=c1298024&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1298024",
  null
  
)

export default component.exports